import ApiService from '@/services/api'

/**
 * @param   {Store}        context
 * @param   {Store.commit} context.commit
 * @param   {object}       payload
 *
 * @returns {object}
 */
const createDetail = async ({ commit }, payload) => {
  const response = await ApiService.createDetail(
    payload.styleId,
    payload.index,
    payload.file
  )
  const detail = response.data

  commit('addDetail', detail)

  return detail
}

/**
 * @param   {Store}        context
 * @param   {Store.commit} context.commit
 * @param   {object}       payload
 *
 * @returns {object}
 */
const updateDetail = async ({ commit }, payload) => {
  const response = await ApiService.updateDetail(
    payload.styleId,
    payload.detailId,
    payload.index
  )
  const detail = response.data

  commit('updateDetail', detail)

  return detail
}

/**
 * @param {Store}        context
 * @param {Store.commit} context.commit
 * @param {Store.state}  context.state
 * @param {object}       payload
 */
const deleteDetail = async ({ commit, state }, payload) => {
  commit('deleteDetail', payload.detailId)

  const detail = await ApiService.deleteDetail(
    payload.styleId,
    payload.detailId
  )

  return detail
}

/**
 * @param   {Store}         context
 * @param   {Store.commit}  context.commit
 * @param   {Store.getters} context.getters
 * @param   {object}        payload
 *
 * @returns {object}
 */
const updateDetailIndexStoreOnly = ({ commit, getters }, payload) => {
  const detail = getters.getDetailById(payload.detailId)

  commit('updateDetail', { ...detail, index: payload.index })

  return detail
}

/**
 * @type {object}
 */
const actions = {
  createDetail,
  updateDetail,
  deleteDetail,
  updateDetailIndexStoreOnly
}

export default actions
